/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-event
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from "zod";

/**
 * Create an Abacus event
 */
export const createAbacusEventHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const createAbacusEventBodyStatementPeriodIdMin = 0;
export const createAbacusEventBodyTargetIdMin = 0;

export const createAbacusEventBody = zod.object({
  event_date: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  event_name: zod
    .enum([
      "approve_sales_files",
      "accounting_period_close",
      "accounting_period_mechanicals",
      "accounting_run_calculate",
      "accounting_run_calculate_nr",
      "accounting_run_commit",
      "adjustment_file_upload",
      "adjustment_file_worksheet_import",
      "apply_pending_adjustments",
      "apply_royalty_correction",
      "apply_royalty_reversal",
      "backfill",
      "calculate_payments",
      "close_balance",
      "collaborators_auto_report_run",
      "commit_advance_payment",
      "commit_batch_payment",
      "commit_mechanicals",
      "commit_reversal_to_subledger",
      "commit_royalties",
      "commit_to_subledger",
      "commit_vat",
      "commit_vat_summary",
      "commit_withholding_tax",
      "confirm_advance_approval",
      "confirm_advance_payment",
      "confirm_approval",
      "confirm_funds",
      "generate_export",
      "ingest_vat_summary",
      "legacy_sync_contract",
      "payment_accepted",
      "payment_approval",
      "payments_generate",
      "payment_returned",
      "release_reserves",
      "return_advance_payment",
      "return_batch_payment",
      "return_vat_summary",
      "return_withholding_tax",
      "approve_sales",
      "get_eligible_sales",
      "ingest_sales_distro",
      "ingest_sales_nr",
      "sap_sync_contract",
      "schedule_reserves",
      "send_payments",
      "stage_royalty_correction",
      "stage_royalty_reversal",
      "statement_period_close",
      "take_reserves",
      "tax_withholding",
      "upload_approval",
    ])
    .describe("Abacus event name, snake-cased"),
  statement_period_id: zod
    .number()
    .min(createAbacusEventBodyStatementPeriodIdMin)
    .optional()
    .describe("Statement period id"),
  target_id: zod
    .number()
    .min(createAbacusEventBodyTargetIdMin)
    .describe("Target id"),
  target_type: zod
    .enum([
      "accounting_period",
      "contract",
      "statement_period_adjustment_file",
      "worksheet_payment_contract_advance",
    ])
    .describe("Name of the foreign table the target_id is associated with."),
});

/**
 * Get an Abacus event by ID
 */
export const getAbacusEventPathAbacusEventIdMin = 0;

export const getAbacusEventParams = zod.object({
  abacus_event_id: zod
    .number()
    .min(getAbacusEventPathAbacusEventIdMin)
    .describe("The ID of the Abacus event"),
});

export const getAbacusEventHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getAbacusEventResponseAbacusEventIdMin = 0;
export const getAbacusEventResponsePreviousAbacusEventIdMin = 0;
export const getAbacusEventResponseStatementPeriodIdMin = 0;
export const getAbacusEventResponseTargetIdMin = 0;

export const getAbacusEventResponse = zod.object({
  abacus_event_id: zod
    .number()
    .min(getAbacusEventResponseAbacusEventIdMin)
    .optional()
    .describe("Abacus event ID"),
  created_by: zod.string().optional(),
  event_date: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  event_name: zod
    .enum([
      "approve_sales_files",
      "accounting_period_close",
      "accounting_period_mechanicals",
      "accounting_run_calculate",
      "accounting_run_calculate_nr",
      "accounting_run_commit",
      "adjustment_file_upload",
      "adjustment_file_worksheet_import",
      "apply_pending_adjustments",
      "apply_royalty_correction",
      "apply_royalty_reversal",
      "backfill",
      "calculate_payments",
      "close_balance",
      "collaborators_auto_report_run",
      "commit_advance_payment",
      "commit_batch_payment",
      "commit_mechanicals",
      "commit_reversal_to_subledger",
      "commit_royalties",
      "commit_to_subledger",
      "commit_vat",
      "commit_vat_summary",
      "commit_withholding_tax",
      "confirm_advance_approval",
      "confirm_advance_payment",
      "confirm_approval",
      "confirm_funds",
      "generate_export",
      "ingest_vat_summary",
      "legacy_sync_contract",
      "payment_accepted",
      "payment_approval",
      "payments_generate",
      "payment_returned",
      "release_reserves",
      "return_advance_payment",
      "return_batch_payment",
      "return_vat_summary",
      "return_withholding_tax",
      "approve_sales",
      "get_eligible_sales",
      "ingest_sales_distro",
      "ingest_sales_nr",
      "sap_sync_contract",
      "schedule_reserves",
      "send_payments",
      "stage_royalty_correction",
      "stage_royalty_reversal",
      "statement_period_close",
      "take_reserves",
      "tax_withholding",
      "upload_approval",
    ])
    .optional()
    .describe("Abacus event name, snake-cased"),
  previous_abacus_event_id: zod
    .number()
    .min(getAbacusEventResponsePreviousAbacusEventIdMin)
    .optional()
    .describe("Abacus event ID"),
  rolled_back_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  statement_period_id: zod
    .number()
    .min(getAbacusEventResponseStatementPeriodIdMin)
    .optional()
    .describe("Statement period id"),
  target_id: zod
    .number()
    .min(getAbacusEventResponseTargetIdMin)
    .optional()
    .describe("Target id"),
  target_type: zod
    .enum([
      "accounting_period",
      "contract",
      "statement_period_adjustment_file",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the foreign table the target_id is associated with."),
});

/**
 * Get all events for a specified target type / id
 */
export const getAbacusEventsByTargetPathTargetIdMin = 0;

export const getAbacusEventsByTargetParams = zod.object({
  target_id: zod
    .number()
    .min(getAbacusEventsByTargetPathTargetIdMin)
    .describe("The ID of the target type"),
  target_type: zod
    .enum([
      "accounting_period",
      "contract",
      "statement_period_adjustment_file",
      "worksheet_payment_contract_advance",
    ])
    .describe("The type of target entity"),
});

export const getAbacusEventsByTargetHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getAbacusEventsByTargetResponseAbacusEventIdMin = 0;
export const getAbacusEventsByTargetResponsePreviousAbacusEventIdMin = 0;
export const getAbacusEventsByTargetResponseStatementPeriodIdMin = 0;
export const getAbacusEventsByTargetResponseTargetIdMin = 0;

export const getAbacusEventsByTargetResponseItem = zod.object({
  abacus_event_id: zod
    .number()
    .min(getAbacusEventsByTargetResponseAbacusEventIdMin)
    .optional()
    .describe("Abacus event ID"),
  created_by: zod.string().optional(),
  event_date: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  event_name: zod
    .enum([
      "approve_sales_files",
      "accounting_period_close",
      "accounting_period_mechanicals",
      "accounting_run_calculate",
      "accounting_run_calculate_nr",
      "accounting_run_commit",
      "adjustment_file_upload",
      "adjustment_file_worksheet_import",
      "apply_pending_adjustments",
      "apply_royalty_correction",
      "apply_royalty_reversal",
      "backfill",
      "calculate_payments",
      "close_balance",
      "collaborators_auto_report_run",
      "commit_advance_payment",
      "commit_batch_payment",
      "commit_mechanicals",
      "commit_reversal_to_subledger",
      "commit_royalties",
      "commit_to_subledger",
      "commit_vat",
      "commit_vat_summary",
      "commit_withholding_tax",
      "confirm_advance_approval",
      "confirm_advance_payment",
      "confirm_approval",
      "confirm_funds",
      "generate_export",
      "ingest_vat_summary",
      "legacy_sync_contract",
      "payment_accepted",
      "payment_approval",
      "payments_generate",
      "payment_returned",
      "release_reserves",
      "return_advance_payment",
      "return_batch_payment",
      "return_vat_summary",
      "return_withholding_tax",
      "approve_sales",
      "get_eligible_sales",
      "ingest_sales_distro",
      "ingest_sales_nr",
      "sap_sync_contract",
      "schedule_reserves",
      "send_payments",
      "stage_royalty_correction",
      "stage_royalty_reversal",
      "statement_period_close",
      "take_reserves",
      "tax_withholding",
      "upload_approval",
    ])
    .optional()
    .describe("Abacus event name, snake-cased"),
  previous_abacus_event_id: zod
    .number()
    .min(getAbacusEventsByTargetResponsePreviousAbacusEventIdMin)
    .optional()
    .describe("Abacus event ID"),
  rolled_back_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  statement_period_id: zod
    .number()
    .min(getAbacusEventsByTargetResponseStatementPeriodIdMin)
    .optional()
    .describe("Statement period id"),
  target_id: zod
    .number()
    .min(getAbacusEventsByTargetResponseTargetIdMin)
    .optional()
    .describe("Target id"),
  target_type: zod
    .enum([
      "accounting_period",
      "contract",
      "statement_period_adjustment_file",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the foreign table the target_id is associated with."),
});
export const getAbacusEventsByTargetResponse = zod.array(
  getAbacusEventsByTargetResponseItem,
);

/**
 * Dataload Abacus events by Abacus event IDs
 */
export const dataloadAbacusEventsHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const dataloadAbacusEventsBodyMin = 0;

export const dataloadAbacusEventsBodyItem = zod
  .number()
  .min(dataloadAbacusEventsBodyMin)
  .describe("Abacus event ID");
export const dataloadAbacusEventsBody = zod.array(dataloadAbacusEventsBodyItem);

export const dataloadAbacusEventsResponseItemsItemDataAbacusEventIdMin = 0;
export const dataloadAbacusEventsResponseItemsItemDataPreviousAbacusEventIdMin = 0;
export const dataloadAbacusEventsResponseItemsItemDataStatementPeriodIdMin = 0;
export const dataloadAbacusEventsResponseItemsItemDataTargetIdMin = 0;

export const dataloadAbacusEventsResponse = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            data: zod.object({
              abacus_event_id: zod
                .number()
                .min(dataloadAbacusEventsResponseItemsItemDataAbacusEventIdMin)
                .optional()
                .describe("Abacus event ID"),
              created_by: zod.string().optional(),
              event_date: zod
                .string()
                .datetime({})
                .optional()
                .describe(
                  "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
                ),
              event_name: zod
                .enum([
                  "approve_sales_files",
                  "accounting_period_close",
                  "accounting_period_mechanicals",
                  "accounting_run_calculate",
                  "accounting_run_calculate_nr",
                  "accounting_run_commit",
                  "adjustment_file_upload",
                  "adjustment_file_worksheet_import",
                  "apply_pending_adjustments",
                  "apply_royalty_correction",
                  "apply_royalty_reversal",
                  "backfill",
                  "calculate_payments",
                  "close_balance",
                  "collaborators_auto_report_run",
                  "commit_advance_payment",
                  "commit_batch_payment",
                  "commit_mechanicals",
                  "commit_reversal_to_subledger",
                  "commit_royalties",
                  "commit_to_subledger",
                  "commit_vat",
                  "commit_vat_summary",
                  "commit_withholding_tax",
                  "confirm_advance_approval",
                  "confirm_advance_payment",
                  "confirm_approval",
                  "confirm_funds",
                  "generate_export",
                  "ingest_vat_summary",
                  "legacy_sync_contract",
                  "payment_accepted",
                  "payment_approval",
                  "payments_generate",
                  "payment_returned",
                  "release_reserves",
                  "return_advance_payment",
                  "return_batch_payment",
                  "return_vat_summary",
                  "return_withholding_tax",
                  "approve_sales",
                  "get_eligible_sales",
                  "ingest_sales_distro",
                  "ingest_sales_nr",
                  "sap_sync_contract",
                  "schedule_reserves",
                  "send_payments",
                  "stage_royalty_correction",
                  "stage_royalty_reversal",
                  "statement_period_close",
                  "take_reserves",
                  "tax_withholding",
                  "upload_approval",
                ])
                .optional()
                .describe("Abacus event name, snake-cased"),
              previous_abacus_event_id: zod
                .number()
                .min(
                  dataloadAbacusEventsResponseItemsItemDataPreviousAbacusEventIdMin,
                )
                .optional()
                .describe("Abacus event ID"),
              rolled_back_at: zod
                .string()
                .datetime({})
                .optional()
                .describe(
                  "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
                ),
              statement_period_id: zod
                .number()
                .min(
                  dataloadAbacusEventsResponseItemsItemDataStatementPeriodIdMin,
                )
                .optional()
                .describe("Statement period id"),
              target_id: zod
                .number()
                .min(dataloadAbacusEventsResponseItemsItemDataTargetIdMin)
                .optional()
                .describe("Target id"),
              target_type: zod
                .enum([
                  "accounting_period",
                  "contract",
                  "statement_period_adjustment_file",
                  "worksheet_payment_contract_advance",
                ])
                .optional()
                .describe(
                  "Name of the foreign table the target_id is associated with.",
                ),
            }),
          })
          .describe("{data: AbacusEvent }"),
      )
      .describe("[ {data: AbacusEvent } ]"),
  })
  .describe("{ items: [ {data: AbacusEvent } ] }");

/**
 * Get the number of current approval events for a Payment Group Payment
 */
export const getPaymentGroupPaymentApprovalCountPathPaymentGroupPaymentIdMin = 0;

export const getPaymentGroupPaymentApprovalCountParams = zod.object({
  payment_group_payment_id: zod
    .number()
    .min(getPaymentGroupPaymentApprovalCountPathPaymentGroupPaymentIdMin)
    .describe("The id of the Payment Group Payment"),
});

export const getPaymentGroupPaymentApprovalCountHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getPaymentGroupPaymentApprovalCountResponseApprovalCountMin = 0;
export const getPaymentGroupPaymentApprovalCountResponsePaymentGroupPaymentIdMin = 0;

export const getPaymentGroupPaymentApprovalCountResponse = zod.object({
  approval_count: zod
    .number()
    .min(getPaymentGroupPaymentApprovalCountResponseApprovalCountMin)
    .describe("Number of approval events"),
  payment_group_payment_id: zod
    .number()
    .min(getPaymentGroupPaymentApprovalCountResponsePaymentGroupPaymentIdMin)
    .describe("PaymentGroupPayment ID"),
});

/**
 * @summary Rolls back an Abacus event
 */
export const rollbackAbacusEventHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const rollbackAbacusEventBodyTargetIdMin = 0;

export const rollbackAbacusEventBody = zod.object({
  event_name: zod
    .enum([
      "approve_sales_files",
      "accounting_period_close",
      "accounting_period_mechanicals",
      "accounting_run_calculate",
      "accounting_run_calculate_nr",
      "accounting_run_commit",
      "adjustment_file_upload",
      "adjustment_file_worksheet_import",
      "apply_pending_adjustments",
      "apply_royalty_correction",
      "apply_royalty_reversal",
      "backfill",
      "calculate_payments",
      "close_balance",
      "collaborators_auto_report_run",
      "commit_advance_payment",
      "commit_batch_payment",
      "commit_mechanicals",
      "commit_reversal_to_subledger",
      "commit_royalties",
      "commit_to_subledger",
      "commit_vat",
      "commit_vat_summary",
      "commit_withholding_tax",
      "confirm_advance_approval",
      "confirm_advance_payment",
      "confirm_approval",
      "confirm_funds",
      "generate_export",
      "ingest_vat_summary",
      "legacy_sync_contract",
      "payment_accepted",
      "payment_approval",
      "payments_generate",
      "payment_returned",
      "release_reserves",
      "return_advance_payment",
      "return_batch_payment",
      "return_vat_summary",
      "return_withholding_tax",
      "approve_sales",
      "get_eligible_sales",
      "ingest_sales_distro",
      "ingest_sales_nr",
      "sap_sync_contract",
      "schedule_reserves",
      "send_payments",
      "stage_royalty_correction",
      "stage_royalty_reversal",
      "statement_period_close",
      "take_reserves",
      "tax_withholding",
      "upload_approval",
    ])
    .describe("Abacus event name, snake-cased"),
  target_id: zod
    .number()
    .min(rollbackAbacusEventBodyTargetIdMin)
    .describe("Target id"),
  target_type: zod
    .enum([
      "accounting_period",
      "contract",
      "statement_period_adjustment_file",
      "worksheet_payment_contract_advance",
    ])
    .describe("Name of the foreign table the target_id is associated with."),
});

export const rollbackAbacusEventResponseAbacusEventIdMin = 0;
export const rollbackAbacusEventResponsePreviousAbacusEventIdMin = 0;
export const rollbackAbacusEventResponseStatementPeriodIdMin = 0;
export const rollbackAbacusEventResponseTargetIdMin = 0;

export const rollbackAbacusEventResponse = zod.object({
  abacus_event_id: zod
    .number()
    .min(rollbackAbacusEventResponseAbacusEventIdMin)
    .optional()
    .describe("Abacus event ID"),
  created_by: zod.string().optional(),
  event_date: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  event_name: zod
    .enum([
      "approve_sales_files",
      "accounting_period_close",
      "accounting_period_mechanicals",
      "accounting_run_calculate",
      "accounting_run_calculate_nr",
      "accounting_run_commit",
      "adjustment_file_upload",
      "adjustment_file_worksheet_import",
      "apply_pending_adjustments",
      "apply_royalty_correction",
      "apply_royalty_reversal",
      "backfill",
      "calculate_payments",
      "close_balance",
      "collaborators_auto_report_run",
      "commit_advance_payment",
      "commit_batch_payment",
      "commit_mechanicals",
      "commit_reversal_to_subledger",
      "commit_royalties",
      "commit_to_subledger",
      "commit_vat",
      "commit_vat_summary",
      "commit_withholding_tax",
      "confirm_advance_approval",
      "confirm_advance_payment",
      "confirm_approval",
      "confirm_funds",
      "generate_export",
      "ingest_vat_summary",
      "legacy_sync_contract",
      "payment_accepted",
      "payment_approval",
      "payments_generate",
      "payment_returned",
      "release_reserves",
      "return_advance_payment",
      "return_batch_payment",
      "return_vat_summary",
      "return_withholding_tax",
      "approve_sales",
      "get_eligible_sales",
      "ingest_sales_distro",
      "ingest_sales_nr",
      "sap_sync_contract",
      "schedule_reserves",
      "send_payments",
      "stage_royalty_correction",
      "stage_royalty_reversal",
      "statement_period_close",
      "take_reserves",
      "tax_withholding",
      "upload_approval",
    ])
    .optional()
    .describe("Abacus event name, snake-cased"),
  previous_abacus_event_id: zod
    .number()
    .min(rollbackAbacusEventResponsePreviousAbacusEventIdMin)
    .optional()
    .describe("Abacus event ID"),
  rolled_back_at: zod
    .string()
    .datetime({})
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz"),
  statement_period_id: zod
    .number()
    .min(rollbackAbacusEventResponseStatementPeriodIdMin)
    .optional()
    .describe("Statement period id"),
  target_id: zod
    .number()
    .min(rollbackAbacusEventResponseTargetIdMin)
    .optional()
    .describe("Target id"),
  target_type: zod
    .enum([
      "accounting_period",
      "contract",
      "statement_period_adjustment_file",
      "worksheet_payment_contract_advance",
    ])
    .optional()
    .describe("Name of the foreign table the target_id is associated with."),
});

/**
 * Check the health of the application.
 */
export const getHealthHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getHealthResponse = zod.object({
  status: zod.enum(["ok"]),
});
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
const z = zod;

const DateTime = z.string();
const AbacusEventName = z.enum([
  "approve_sales_files",
  "accounting_period_close",
  "accounting_period_mechanicals",
  "accounting_run_calculate",
  "accounting_run_calculate_nr",
  "accounting_run_commit",
  "adjustment_file_upload",
  "adjustment_file_worksheet_import",
  "apply_pending_adjustments",
  "apply_royalty_correction",
  "apply_royalty_reversal",
  "backfill",
  "calculate_payments",
  "close_balance",
  "collaborators_auto_report_run",
  "commit_advance_payment",
  "commit_batch_payment",
  "commit_mechanicals",
  "commit_reversal_to_subledger",
  "commit_royalties",
  "commit_to_subledger",
  "commit_vat",
  "commit_vat_summary",
  "commit_withholding_tax",
  "confirm_advance_approval",
  "confirm_advance_payment",
  "confirm_approval",
  "confirm_funds",
  "generate_export",
  "ingest_vat_summary",
  "legacy_sync_contract",
  "payment_accepted",
  "payment_approval",
  "payments_generate",
  "payment_returned",
  "release_reserves",
  "return_advance_payment",
  "return_batch_payment",
  "return_vat_summary",
  "return_withholding_tax",
  "approve_sales",
  "get_eligible_sales",
  "ingest_sales_distro",
  "ingest_sales_nr",
  "sap_sync_contract",
  "schedule_reserves",
  "send_payments",
  "stage_royalty_correction",
  "stage_royalty_reversal",
  "statement_period_close",
  "take_reserves",
  "tax_withholding",
  "upload_approval",
]);
const StatementPeriodId = z.number();
const TargetId = z.number();
const TargetType = z.enum([
  "accounting_period",
  "contract",
  "statement_period_adjustment_file",
  "worksheet_payment_contract_advance",
]);
const AbacusEventId = z.number();
const PartialAbacusEvent = z
  .object({
    abacus_event_id: AbacusEventId.int().gte(0).describe("Abacus event ID"),
    created_by: z.string(),
    event_date: DateTime.datetime({ offset: true }).describe(
      "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
    ),
    event_name: AbacusEventName.describe("Abacus event name, snake-cased"),
    previous_abacus_event_id: AbacusEventId.int()
      .gte(0)
      .describe("Abacus event ID"),
    rolled_back_at: DateTime.datetime({ offset: true }).describe(
      "A datetime string formatted as YYYY-MM-DDTHH:MM:SS.fz",
    ),
    statement_period_id: StatementPeriodId.int()
      .gte(0)
      .describe("Statement period id"),
    target_id: TargetId.int().gte(0).describe("Target id"),
    target_type: TargetType.describe(
      "Name of the foreign table the target_id is associated with.",
    ),
  })
  .partial()
  .passthrough();
const AbacusEvent = PartialAbacusEvent;
const PaymentGroupPaymentId = z.number();
const PaymentGroupPaymentApprovalCount = z
  .object({
    approval_count: z
      .number()
      .int()
      .gte(0)
      .describe("Number of approval events"),
    payment_group_payment_id: PaymentGroupPaymentId.int()
      .gte(0)
      .describe("The id of the Payment Group Payment"),
  })
  .passthrough();
const Health = z.object({ status: z.literal("ok") }).passthrough();

export const dateTime = DateTime;
export const abacusEventName = AbacusEventName;
export const statementPeriodId = StatementPeriodId;
export const targetId = TargetId;
export const targetType = TargetType;
export const abacusEventId = AbacusEventId;
export const partialAbacusEvent = PartialAbacusEvent;
export const abacusEvent = AbacusEvent;
export const paymentGroupPaymentId = PaymentGroupPaymentId;
export const paymentGroupPaymentApprovalCount =
  PaymentGroupPaymentApprovalCount;
export const health = Health;
